import { BarChart3, CalendarDays, ChevronRight, Flame, Images, Palette, PlugZap, UserCog, Users } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const READY = [
  { icon: PlugZap, title: 'Conexión con VTEX', desc: 'Credenciales de tu cuenta VTEX', to: '/admin/conexion', tourId: 'admin-conexion' },
  { icon: BarChart3, title: 'Dashboard consolidado', desc: 'Rendimiento del equipo + export CSV', to: '/admin/dashboard', tourId: 'admin-dashboard' },
  { icon: Users, title: 'Gestión de vendedores', desc: 'Alta/baja/edición + import CSV', to: '/admin/vendedores', tourId: 'admin-vendedores' },
  { icon: Flame, title: 'Hot Items / Novedades', desc: 'Colecciones VTEX + vigencia', to: '/admin/colecciones', tourId: 'admin-colecciones' },
  { icon: UserCog, title: 'Administradores', desc: 'Gestión de accesos admin', to: '/admin/admins', tourId: 'admin-admins' },
  { icon: Palette, title: 'Marca (White Label)', desc: 'Logo, color y nombre', to: '/admin/marca', tourId: 'admin-marca' },
  { icon: Images, title: 'Banners de Social Selling', desc: 'Imágenes descargables del modal', to: '/admin/banners', tourId: 'admin-banners' },
  { icon: CalendarDays, title: 'Calendario de contenido', desc: 'Publicaciones del equipo', to: '/admin/calendario', tourId: 'admin-calendario' },
]

const SOON = [] as { icon: typeof CalendarDays; title: string; desc: string }[]

export function AdminHome() {
  const navigate = useNavigate()
  return (
    <div className="space-y-4 p-4">
      <header>
        <h2 className="text-lg font-bold text-ink">Panel de administración</h2>
        <p className="text-sm text-ink-muted">Gestión de la instancia y del equipo.</p>
      </header>

      <div className="grid gap-3">
        {READY.map(({ icon: Icon, title, desc, to, tourId }) => (
          <button
            key={title}
            data-tour={tourId}
            onClick={() => navigate(to)}
            className="card flex items-center gap-3 p-4 text-left active:bg-surface-sunken"
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-xl accent-bg-soft accent-text">
              <Icon className="h-5 w-5" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-ink">{title}</p>
              <p className="text-xs text-ink-muted">{desc}</p>
            </div>
            <ChevronRight className="h-4 w-4 text-ink-faint" />
          </button>
        ))}

        {SOON.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="card flex items-center gap-3 p-4 opacity-60">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-surface-sunken text-ink-muted">
              <Icon className="h-5 w-5" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-ink">{title}</p>
              <p className="text-xs text-ink-muted">{desc}</p>
            </div>
            <span className="badge">Pronto</span>
          </div>
        ))}
      </div>
    </div>
  )
}
